import { Notification, NotificationType } from "@/types";
import { getData, deleteData } from "./axios-service"


function modelMapper(inputNotification: any): Notification {
    return {
        id: inputNotification.id,
        name: inputNotification.name,
        notificationType: inputNotification.notificationType,
        desc: inputNotification.desc,
        relatedEntity: inputNotification.relatedEntity,
        bgColor: inputNotification.bgColor,
        iconClass: inputNotification.iconClass,
        icon: inputNotification.icon
    };
}

export function modelMapperArray(inputArray: any[]): Notification[] {
    return inputArray.map(modelMapper);
}

export async function getAllNotifications(): Promise<Notification[]> {
    const notifications = await getData<Notification[]>("notifications");
    return modelMapperArray(notifications ?? []);
}

export async function getNotificationsByType(notificationType: NotificationType): Promise<Notification[]> {
    const notifications = await getData<Notification[]>("notifications?type=" + notificationType);
    return modelMapperArray(notifications ?? []);
}


export function deleteNotification(id: string): Promise<any> {
    return deleteData("notifications/" + id)
}